module.exports = __webpack_public_path__ + "img/sv80on.7e8bafd7.svg";